import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
//import { HttpModule } from "@angular/http";
import { IonicStorageModule } from '@ionic/storage-angular';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
//import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { HeaderPageModule } from './header/header.module';
import { FooterPageModule } from './footer/footer.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';
import { ChatBubblePageModule } from './chat-bubble/chat-bubble.module';
//const config: SocketIoConfig = { url: "http://localhost:2021/", options: {} };
/* const config: SocketIoConfig = {
  url: 'http://206.81.1.106:2021/',
  //url: "",
  options: {},
}; */

const config: SocketIoConfig = {
  url: 'https://socket.courierandbeyond.com/',
  //url: "",
  options: {},
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    //HttpModule,
    HttpClientModule,
    SocketIoModule.forRoot(config),
    HeaderPageModule,
    FooterPageModule,
    ChatBubblePageModule,
  ],

  providers: [
    FileOpener,
    SocialSharing,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
